import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";
import "../../../_metronic/_assets/sass/components/Announcements/Announcements.scss";

import React from "react";
import {
  Eye,
  Bell,
  FileText,
  Paperclip,
  Image,
  Video,
  Link,
  FileIcon,
  Headphones,
} from "lucide-react";

const iconStyles = {
  color: "#1196c0",
  width: "20px",
  height: "20px",
};

export const getTypeIcon = (value) => {
  let type = value?.toLowerCase();
  switch (type) {
    case "document":
      return <Paperclip style={iconStyles} />;
    case "image":
      return <Image style={iconStyles} />;
    case "text":
      return <FileText style={iconStyles} />;
    case "video":
      return <Video style={iconStyles} />;
    case "link":
      return <Link style={iconStyles} />;
    case "pdf":
      return <FileIcon style={iconStyles} />;
    case "audio":
      return <Headphones style={iconStyles} />;
    default:
      return <FileText style={iconStyles} />;
  }
};

const CardViewContentStaff = ({
  setModalContent,
  data,
  view,
  handleOpenNotificationModal,
}) => {
  return (
    <Grid container spacing={2} style={{ padding: "30px 30px" }}>
      {data.map((annc) => {
        return (
          <Grid
            item
            key={annc.id}
            xs={12}
            sm={6}
            md={6}
            lg={3}
            xl={2}
            style={{ minHeight: "100% !important" }}
          >
            <Card
              style={{ margin: "5px", height: "100%" }}
              className="card-item-announcements"
            >
              <CardActionArea
                id="edit_announce_card_action"
                style={{ height: "100%" }}
              >
                <CardContent onClick={() => view(annc.id)}>
                  <div
                    style={{
                      width: "100%",
                      marginBottom: "10px",
                      display: "flex",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "10%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {getTypeIcon(annc.file_type)}
                    </div>
                    <div style={{ width: "90%" }}>
                      <Typography
                        variant="h5"
                        style={{
                          fontWeight: "600",
                          fontSize: "20px",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {annc.title}
                      </Typography>
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      paddingLeft: "30px",
                      marginBottom: "50px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "5px",
                    }}
                  >
                    <span
                      style={{
                        color: "#1e40b7",
                        backgroundColor: "#dbeafe",
                        borderRadius: "1000px",
                        padding: "5px 15px",
                        fontSize: "12px",
                        fontWeight: "500",
                        textAlign: "center",
                      }}
                    >
                      {annc.focus_area[0]?.name
                        ? annc.focus_area[0].name
                        : "---"}
                    </span>
                  </div>
                </CardContent>
                <CardActions>
                  <Grid container item xs={12} spacing={1}>
                    <Grid item xs={12} md={6}>
                      <button
                        onClick={() => handleOpenNotificationModal(annc.id)}
                        className="btn-actions-card-announcements"
                      >
                        <Bell
                          style={{
                            width: "14px",
                            height: "14px",
                          }}
                        />
                        <span style={{ marginLeft: "10px !important" }}>
                          Send
                        </span>
                      </button>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <button
                        onClick={() =>
                          setModalContent({
                            openModal: true,
                            content: annc.resource_url,
                            type: annc.file_type,
                          })
                        }
                        className="btn-actions-card-announcements"
                      >
                        <Eye
                          style={{
                            width: "14px",
                            height: "14px",
                          }}
                        />
                        <span style={{ marginLeft: "10px !important" }}>
                          View
                        </span>
                      </button>
                    </Grid>
                  </Grid>
                </CardActions>
              </CardActionArea>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CardViewContentStaff;
